import React from "react";
import { useSearchParams } from 'react-router-dom';
import { searchParamsObj } from "../utils/dataHandler";

function useIsGovInParams() {
    const [ searchParams ] = useSearchParams();
    const selectedGov = searchParamsObj(searchParams)?.gov;
    const isGovInParams = selectedGov?true:false
    return isGovInParams as boolean;
};

export default useIsGovInParams; 
